export default __webpack_public_path__ + "static/media/cancelWhite.c025e533.svg";